module.exports = __webpack_public_path__ + "img/advanced-tools.95984d8a.svg";